import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPencil = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.091 2.76471L9.20723 0.874141C8.96137 0.64237 8.6392 0.509384 8.302 0.500478C7.96481 0.491572 7.63612 0.607369 7.37845 0.825842L1.19089 7.03575C0.968659 7.26067 0.830291 7.55546 0.799006 7.87064L0.503378 10.7479C0.494116 10.849 0.507183 10.9508 0.541645 11.0462C0.576108 11.1417 0.631118 11.2283 0.702755 11.2999C0.766996 11.3638 0.843183 11.4144 0.926947 11.4488C1.01071 11.4831 1.1004 11.5005 1.19089 11.5H1.25276L4.11967 11.2378C4.43372 11.2064 4.72745 11.0675 4.95155 10.8445L11.1391 4.63459C11.3793 4.37996 11.5091 4.04017 11.5 3.68967C11.491 3.33917 11.3439 3.00656 11.091 2.76471V2.76471ZM3.99592 9.85781L1.93339 10.051L2.11902 7.98104L6.00344 4.13089L7.85971 5.99387L3.99592 9.85781ZM8.75347 5.06928L6.91095 3.22011L8.25159 1.84013L10.1285 3.7238L8.75347 5.06928Z",
		fill: "var(--color, #123C70)"
	})
});
export default SvgPencil;
